/* FAQ — accordion + category switching as progressive enhancement.
   Content is fully rendered/visible server-side; this only adds collapse behaviour
   once JS runs (the section gets .is-enhanced), so crawlers & no-JS users see everything.
   - "All" (data-cat="__all__") shows every category at once.
   - Clicking a question animates open/close; switching category opens the first answer
     instantly (no height animation) so the container doesn't collapse-then-grow. */
(function () {
  function initSection(root) {
    root.classList.add('is-enhanced');
    var cats = Array.prototype.slice.call(root.querySelectorAll('.faq-cat'));
    var groups = Array.prototype.slice.call(root.querySelectorAll('.faq-group'));
    var allQ = Array.prototype.slice.call(root.querySelectorAll('.faq-q'));

    function setOpen(q, open, instant) {
      var body = q.querySelector('.faq-q-body');
      var head = q.querySelector('.faq-q-head');
      if (instant) body.style.transition = 'none';
      if (open) { q.classList.add('open'); head.setAttribute('aria-expanded', 'true'); body.style.maxHeight = body.scrollHeight + 'px'; }
      else { q.classList.remove('open'); head.setAttribute('aria-expanded', 'false'); body.style.maxHeight = null; }
      if (instant) { void body.offsetHeight; body.style.transition = ''; } // commit, then restore transition
    }
    function openFirstOf(group, instant) {
      if (!group) return;
      var firstQ = group.querySelector('.faq-q');
      if (firstQ) setOpen(firstQ, true, instant);
    }
    function selectCat(key, instant) {
      cats.forEach(function (x) { var on = x.getAttribute('data-cat') === key; x.classList.toggle('is-active', on); x.setAttribute('aria-selected', on ? 'true' : 'false'); });
      var active = [];
      groups.forEach(function (g) {
        var on = key === '__all__' || g.getAttribute('data-group') === key;
        g.classList.toggle('is-active', on);
        if (on) active.push(g);
      });
      allQ.forEach(function (q) { setOpen(q, false, true); });   // reset all, instantly
      openFirstOf(active[0], true);                              // instant: no height jump on switch
      if (!instant) {
        // re-trigger the fade on every visible group so EVERY tab click animates consistently
        active.forEach(function (g) { g.classList.remove('faq-anim'); });
        void root.offsetWidth;                                   // reflow to restart the animation
        active.forEach(function (g) { g.classList.add('faq-anim'); });
      }
    }

    allQ.forEach(function (q) {
      q.querySelector('.faq-q-head').addEventListener('click', function () {
        var isOpen = q.classList.contains('open');
        root.querySelectorAll('.faq-q.open').forEach(function (o) { if (o !== q) setOpen(o, false); }); // one open at a time
        setOpen(q, !isOpen); // animated for direct interaction
      });
    });

    cats.forEach(function (c) {
      c.addEventListener('click', function () { selectCat(c.getAttribute('data-cat')); });
    });

    var t;
    window.addEventListener('resize', function () {
      clearTimeout(t);
      t = setTimeout(function () {
        root.querySelectorAll('.faq-q.open').forEach(function (q) {
          var b = q.querySelector('.faq-q-body'); b.style.transition = 'none'; b.style.maxHeight = b.scrollHeight + 'px'; void b.offsetHeight; b.style.transition = '';
        });
      }, 150);
    });

    // init: honour the active category button (defaults to "All"); no rail -> just open first
    var startCat = cats.filter(function (c) { return c.classList.contains('is-active'); })[0] || cats[0];
    if (startCat) selectCat(startCat.getAttribute('data-cat'), true);
    else openFirstOf(groups[0], true);
  }
  function init() { document.querySelectorAll('.faq-sec').forEach(initSection); }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
